import { Anchor } from "antd";
import React from "react";

import styles from "./AccountSettingsPage.module.scss";

import { DataAccess } from "../../components/AccountSettings/components/DataAccess/DataAccess";
import { Integrations } from "../../components/AccountSettings/components/Integrations";
import { SectionTitle } from "../../components/AccountSettings/components/SectionTitle";
import { Subscription } from "../../components/AccountSettings/components/Subscription";
// import { ComingSoonData } from "../../components/ConnectData/components/ComingSoonData";

const items = [
  {
    id: "pricing",
    title: "Pricing",
    description: "We believe Friday Report should be accessible to all companies, no matter the size",
    children: <Subscription />
  },
  {
    id: "dataAccess",
    title: "Data access",
    description: "Manage your data access and permissions",
    children: <DataAccess />
  },
  {
    id: "dataSources",
    title: "Data sources",
    description: "Connect your data sources to Friday Report",
    children: <Integrations />
  }
]

export const AccountSettingsPage = () => {
  return (
    <div className={styles.root}>
      <div className={styles.sections}>
        {items.map((props) => <Section {...props} />)}
      </div>
      <div className={styles.anchor}>
        <Anchor
          items={items.map((item) => ({
            key: item.id,
            href: `#${item.id}`,
            title: item.title,
          }))}
          />
      </div>
    </div>
  );
};

const Section = ({
  id,
  title,
  description,
  children
}: {
  id: string;
  title: string;
  description: string;
  children: React.ReactNode;
}): React.ReactElement => {
  return (
    <div id={id} className={styles.section}>
      <div className={styles.titleWrapper}>
        <SectionTitle
          title={title}
          description={description}
        />
      </div>
      {children}
    </div>
  );
}
